// removed by extract-text-webpack-plugin
module.exports = {"Haricot":"#01A92B","alertContent":"G376d91","alertIconWrapper":"G8b0e19","alertIcon":"G70142e","alertText":"G350847 G982276","creditCopy":"G9681a2 Gd05560"};